import { render, staticRenderFns } from "./paymentLink.vue?vue&type=template&id=c0ff6646&scoped=true"
import script from "./paymentLink.vue?vue&type=script&lang=js"
export * from "./paymentLink.vue?vue&type=script&lang=js"
import style0 from "./paymentLink.vue?vue&type=style&index=0&id=c0ff6646&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ff6646",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0ff6646')) {
      api.createRecord('c0ff6646', component.options)
    } else {
      api.reload('c0ff6646', component.options)
    }
    module.hot.accept("./paymentLink.vue?vue&type=template&id=c0ff6646&scoped=true", function () {
      api.rerender('c0ff6646', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/payment-link/components/tabs/paymentLink.vue"
export default component.exports